module.exports = __webpack_public_path__ + "static/suburban_350-d698a383f6f20bae9faceb4bc4fb4bea.webp";